import { render, staticRenderFns } from "./RegistrationFormEditPage.vue?vue&type=template&id=1d8906e7&scoped=true&"
import script from "./RegistrationFormEditPage.vue?vue&type=script&lang=js&"
export * from "./RegistrationFormEditPage.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationFormEditPage.vue?vue&type=style&index=0&id=1d8906e7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8906e7",
  null
  
)

export default component.exports